export default "__VITE_ASSET__C8b1s18B__"